import { Caption } from '@components/utils/text';
import styled from '@emotion/styled';
import { AdditionalProductFragment } from '@graphql/generated/graphql';
import StrapiImage from '@lib/image/strapiImage';
import { getStrapiAssetUrl } from '@lib/strapi';
import { VStack } from '@lib/uikit';

type Props = { additionalProduct: AdditionalProductFragment };

const SStrapiImage = styled(StrapiImage)`
    object-fit: cover;
    border-radius: ${({ theme }) => theme.shape.radius.default};
`;

const Title = styled.p`
    font: ${({ theme }) => theme.fonts.heading3};
    color: ${({ theme }) => theme.palette.text.primary};
`;

export const AdditionalProductFlowPagePreview = ({
    additionalProduct,
}: Props) => {
    return (
        <VStack align='center' textAlign='center'>
            <SStrapiImage
                sizes='13rem'
                src={getStrapiAssetUrl(additionalProduct.Image)}
                formats={additionalProduct.Image?.formats}
                alt={
                    additionalProduct.Image?.alternativeText ??
                    additionalProduct.Name
                }
            />
            <Title>{additionalProduct.Name}</Title>
            {additionalProduct.Description && (
                <Caption>{additionalProduct.Description}</Caption>
            )}
        </VStack>
    );
};
